module.exports = {"information":"Thông tin","waiting":"Đang chờ xác thực"};